import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { element } from '@angular/core/src/render3/instructions';
import { map } from 'jquery';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})


export class TableComponent implements OnInit {

  @Input() id: string;
  @Input() label: string;
  @Input() value: string;
  @Input() required: boolean;
  @Input() canSelectMultipleValues: boolean;
  @Input() options: {[field: string]: string};
  @Output() valueChanged: EventEmitter<string> = new EventEmitter();
  @Output() handleValidate: EventEmitter<boolean> = new EventEmitter();

  jsonValue: Array<{[field: string]: string}>;

  indexToDelete: number;

  constructor() {
  }

  ngOnInit() {
    if (this.value != null) {
      try {
        this.jsonValue = JSON.parse(this.value);
        return;
      } catch (error) {}
    }

    this.jsonValue = [];
    this.addRow();
  }

  getOptionKeys() {
      return Object.keys(this.options).map(key => key);
  }

  onValueChanged(jsonValue: Array<{[field: string]: string}>) {
    this.validate(jsonValue);
    this.value = JSON.stringify(this.jsonValue);
  
    this.valueChanged.emit(this.value);
  }
  
  validate(value: Array<{[field: string]: string}>) {
    if (this.required === false) {
      this.handleValidate.emit(true);
      return;
    }

    let firstObject = value[0];

    if (firstObject == null) {
      this.handleValidate.emit(true);
      return;
    }

    let firstKey = Object.keys(firstObject)[0];

    if (firstKey == null) {
      this.handleValidate.emit(true);
      return;
    }

    let firstValue = firstObject[firstKey];

    if (firstValue == '' || firstValue == null) {
      this.handleValidate.emit(true);
      return;
    }

    this.handleValidate.emit(false);
  }

  addRow() {
    this.jsonValue.push({});
  }

  deleteRow(row : {[field: string]: string}) {
    for (this.indexToDelete = 0; this.indexToDelete < this.jsonValue.length; this.indexToDelete++) {
        if (this.jsonValue[this.indexToDelete] === row) {
           this.jsonValue.splice(this.indexToDelete,1); 
           this.valueChanged.emit(JSON.stringify(this.jsonValue));
        }
    }
  }

}